<template>
  <div
    class="lego-radio lego-input"
    :class="radioClass"
    :tabindex="isDisabled"
    @keydown.enter.stop.prevent="onKeydownEnter"
    @keydown.space.stop.prevent="onKeydownSpace"
    @click.stop="onClick"
  >
    <div
      class="lego-radio__icon"
      :class="{ 'lego-radio__unchecked': !clicked, 'lego-radio__checked': clicked }"
    />
    <span class="lego-radio__label" v-if="$slots.default" :style="radioLabelStyle">
      <slot />
    </span>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    labelMaxWidth: {
      type: [String, Number],
      default: undefined,
    },
    checked: {
      type: [Boolean, String, Object],
    },
    value: {
      type: [Boolean, String, Object],
      default: true,
    },
    valueKey: { type: String, default: '' },
  },
  computed: {
    radioLabelStyle() {
      return {
        'max-width': this.labelMaxWidth + 'px',
        'word-break': 'break-all',
      };
    },
    clicked() {
      if (typeof this.value === 'object') {
        if (this.valueKey) {
          return this.actualVModel[this.valueKey] === this.value[this.valueKey];
        } else {
          return this.actualVModel.value === this.value.value;
        }
      } else {
        return this.actualVModel === this.value;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.lego-radio {
  align-items: center;

  &:focus {
    &:after {
      display: none;
    }
  }

  .lego-radio__icon {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }

  &__unchecked {
    border: 1px solid $color--ui06;
    background: $color--ui-white;

    &:hover {
      border: 1px solid $color--primary;
    }
  }

  &__checked {
    border: 1px solid $color--primary;
    background: $color--ui-white;

    &:before {
      position: absolute;
      top: calc(50% - 5px);
      left: calc(50% - 5px);
      content: '';
      width: 10px;
      height: 10px;
      background: $color--primary;
      border-radius: 50%;
      display: inline-block;
    }
  }

  &--disabled {
    .lego-radio__checked {
      border-color: $color--primary-tint03;
      &:before {
        background: $color--primary-tint03;
      }
    }
    .lego-radio__unchecked {
      background: $color--ui11;
    }
  }
}
</style>
